import { IconName } from '../ui/Icon/Icon';
import { MetricCard } from './MetricCard/MetricCard';
import styles from './MetricCards.module.css';

type MetricCardsProps = {
  metrics: {
    iconName: IconName;
    label: string;
    value: string;
  }[];
};

export const MetricCards = ({ metrics }: MetricCardsProps) => {
  return (
    <div className={styles.cardsContainer}>
      {metrics.map((metric, index) => (
        <MetricCard key={index} iconName={metric.iconName} title={metric.label} value={metric.value} />
      ))}
    </div>
  );
};
